import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../Utils/authHeader";
import Layout from "../Layout";

export default function PrivateRoute({ children }) {
  const navigate = useNavigate();
  let token = getAccessToken();
  useEffect(() => {
    if (!token) {
      navigate("/superadmin", { replace: true });
    }
  }, [token]);

  // Without a token, rendering the layout would fire API calls that just 401.
  if (!token) return null;

  return (
    <>
      <Layout>{children}</Layout>
    </>
  );
}
